// Copyright (c) 2020 Deere & Company

import SpaAccordion from './spa-accordion';
import actionCreators from '../../action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    spaClaims: state.tabm.wip.specialAllowanceClaims,
    spaClaimsSearchFilters: state.tabm.wip.specialAllowanceClaimsSearchFilters
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {routeParams} = parentProps;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(SpaAccordion);



// WEBPACK FOOTER //
// ./src/tabm/wip/components/special-allowance/index.js